<script setup lang="ts">
  import {
    ComboboxInput,
    type ComboboxInputEmits,
    type ComboboxInputProps,
    useForwardPropsEmits
  } from 'reka-ui'
  import type { HTMLAttributes } from 'vue'
  import { computed } from 'vue'
  import { cn } from '../../../lib/utils'

  defineOptions({ inheritAttrs: false })

  const props = defineProps<
    ComboboxInputProps & { class?: HTMLAttributes['class'] }
  >()
  const emits = defineEmits<ComboboxInputEmits>()

  const delegatedProps = computed(() => {
    const { class: _, ...rest } = props
    return rest
  })
  const forwarded = useForwardPropsEmits(delegatedProps, emits)
</script>

<template>
  <ComboboxInput
    data-slot="combobox-input"
    v-bind="{ ...forwarded, ...$attrs }"
    :class="
      cn(
        'flex h-9 w-full min-w-0 bg-transparent px-3 py-1 text-base outline-none placeholder:text-neutral-400 disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 dark:placeholder:text-neutral-500 md:text-sm',
        props.class
      )
    "
  />
</template>
